// Role type definitions

export type RoleType = "user" | "admin";

export interface IRole {
  id?: number;
  role_name: string;
  role_description: string;
  role_type?: RoleType;
  created_on?: string;
  updated_on?: string;
  is_active?: boolean;
}

export interface IRoleCreatePayload {
  role_name: string;
  role_description: string;
  role_type?: RoleType;
}

export interface IRoleUpdatePayload {
  role_name: string;
  role_description: string;
  role_type?: RoleType;
}

export interface IRoleListItem extends IRole {
  // Additional fields that might be present in list responses
  users_count?: number;
  permissions_count?: number;
}

// Helper function to check if a role is admin type
export const isAdminRole = (role: IRole | IRoleListItem | null | undefined): boolean => {
  return role?.role_type?.toLowerCase() === "admin";
};

// Helper function to get role type with fallback
export const getRoleType = (role: IRole | IRoleListItem | null | undefined): RoleType => {
  return role?.role_type || "user";
};
